import { SpecialType } from "@ssf/memdb-api";
import { useTranslation } from "react-i18next";
import { getClubStatus, getIssues, getTasks } from "../../lib/index.js";
export const useClubTasks = (club, currentMemberId, contenderIssues) => {
    const { t } = useTranslation("issuesV2");
    return getClubTasks(club, t, currentMemberId, contenderIssues);
};
export const getClubTasks = (club, t, currentMemberId, contenderIssues) => {
    if (!club || !club.startdate)
        return;
    return getTasks({
        issues: getIssues({
            clubStatus: club.approvalStatus,
            contenderIssues,
            isClubApproved: club.specialType !== SpecialType.Temp,
        }),
        clubApprovalStatus: club.approvalStatus,
        registrations: (club.registrations ?? []).filter((registration) => registration.memberid !== currentMemberId &&
            new Date(registration.date).getFullYear() === new Date().getFullYear()),
        clubId: club.id,
        ...getClubStatus(club),
        t,
    });
};
//# sourceMappingURL=useClubTasks.js.map